import React, { useEffect, useState } from "react";
import Icons from "./Icons";
const BackToTop = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateScrollProgress = () => {
      const scrollTop = window.scrollY;
      const windowHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress = (scrollTop / windowHeight) * 100;
      setScrollProgress(progress);
      setIsVisible(scrollTop > 100);
    };
    window.addEventListener("scroll", updateScrollProgress);
    return () => window.removeEventListener("scroll", updateScrollProgress);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <button
      title="back to top"
      onClick={scrollToTop}
      className={`size-12 md:size-14 flex items-center justify-center rounded-full bg-custom-white text-black z-50 shadow shadow-custom-blue relative ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{
        border: `4px solid transparent`,
        backgroundClip: "padding-box",
        position: "relative",
      }}>
      <Icons icon="back-top-arrow" className="size-6" />
      <svg
        className="absolute h-full w-full top-0 left-0 scale-[1.2]"
        viewBox="0 0 36 36">
        <circle
          cx="18"
          cy="18"
          r="16"
          fill="none"
          stroke="#297D4E"
          strokeWidth="2"
          strokeDasharray="100"
          strokeDashoffset={100 - scrollProgress}
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
};

export default BackToTop;
